import './spinner_loader.css';

export const SpinnerLoader = () => {
    return (
        <div className='spiner_loader'>

        </div>
    );
}